import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

import {Line} from '@models/line.model';

import {TableConfig} from '@app/shared/util/table-config.utils';

import 'rxjs/add/operator/map';

import {environment} from '../../../environments/environment';
import {PagedResponse} from "@models/response.model";
import {AppUtils} from "@app/shared/util/app.utils";
import * as _ from 'lodash';
import { map } from "rxjs/operators";

/**
 * Service class for handling CRUD operations on {@link Line} objects.
 */
@Injectable()
export class LineService {

    static readonly LINES_API_GET_PATH = `${environment.baseURL}/api/lines`;
    static readonly LINES_API_REPORT_DOWNLOAD_PATH = environment.baseURL + '/api/lines/download';


    constructor(private http: HttpClient) { }

    getAllLines(tableConfig = null) {

        const params = AppUtils.buildPageableParams(tableConfig);
        return this.http.get<PagedResponse<Line>>(LineService.LINES_API_GET_PATH, {params: params})
        .pipe(map(this.mapResponse));
    }

    createLine(line) {
        return this.http.post<Line>(LineService.LINES_API_GET_PATH, this.getLineCopy(line));
    }

    updateLine(line) {
        const copyLine = this.getLineCopy(line);
        return this.http.put<Line>(`${LineService.LINES_API_GET_PATH}/${copyLine.id}`, copyLine);
    }

    deleteLine(line) {
        return this.http.delete<Line>(`${LineService.LINES_API_GET_PATH}/${line.id}`);
    }

    private mapResponse = res => {
        return {
            items: res.items.map(item => new Line(item)),
            total: res.total
        };
    };

    getLineCopy(line) {
        const lineLocations = [];
        line.lineLocations.forEach(location => {
            lineLocations.unshift({'id': location.id != null ? location.id : 0, 'name': location.name, 'lineId': line.id});
        })
        const copyLine: any = {
            id: line.id,
            name: line.name,
            description: line.description,
            mesId : line.mesId,
            locationId : line.locationId,
            lineLocations : lineLocations,
            isSPI: line.isSPI,
            equipment : _.map(line.equipment, 'id'),
            plantId :  line.plant.id || line.plant,
            insertionCycles: _.map(line.insertionCycles, 'id'),
            toolRequestsLimit: line.toolRequestsLimit,
            contactEmailAddress: line.contactEmailAddress || null,
            toolMaxTransportTime: line.toolMaxTransportTime,
            isDeleted: line.isDeleted
        };
        return copyLine;
    }

    downloadLinesReport(requestConfig: TableConfig = null) {
        const params = AppUtils.buildPageableParams(requestConfig);
        return this.http.get(LineService.LINES_API_REPORT_DOWNLOAD_PATH,
            {observe: 'response', params: params, responseType: 'blob'});
    }

}
